import axios from 'axios';
import get from "lodash/get";
import {
    ERR_MSG,
    UNAUTH_STAT_CODE,
    UNAUTH_STAT_CODE_101,
    VAL_TOK_ERR_101,
    VAL_TOK_ERR_105
} from "../constants/constants";
import {store} from "../store/store";
import {loadSessionExpired} from "../store/action";
import {env, SERVER_URL} from "../config/url-config";
import Cookies from 'js-cookie';
import {RefreshTokenService} from "../services/refreshtokenservice";

export const axiosInstance = axios.create({
    baseURL: get(SERVER_URL,env),
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});
const SESSION_EXPIRED_STAT_CODE=[UNAUTH_STAT_CODE,VAL_TOK_ERR_101,VAL_TOK_ERR_105]
 axiosInstance.interceptors.request.use((config)=>{
     let cookie = Cookies.get("csrtoken")
     console.log("Request Interceptor",config.url)
     if(cookie){
         config.headers= config.headers || {}
         config.headers['X-CSRF-TOKEN'] = cookie;
     }

     return config

 })
axiosInstance.interceptors.response.use(async function (response) {
    // Do something with response data

    // let serviceResponseHeader = get(data,"serviceResponseHeader");
    // let statusCode = get(serviceResponseHeader,"statusCode");
    // console.log("interceptors response",response)
    // console.log("interceptors statusCode",statusCode)
    // if(statusCode === UNAUTH_STAT_CODE){
    //     store.dispatch(loadSessionExpired(true))
    //     return Promise.reject(ERR_MSG);
    // }
    let config=response.config;
    console.log("Response Interceptor",config.url)
    const statusCode = get(response,"data.serviceResponseHeader.statusCode")
    console.log("config success",config)
    if (SESSION_EXPIRED_STAT_CODE.includes(statusCode)  && !config.sent){
        config._retry=true;
        const refreshTokenResponse=await RefreshTokenService();
        console.log("API Response",config.url)
        return axiosInstance.request(config)
    }else if(statusCode ===UNAUTH_STAT_CODE_101){
        store.dispatch(loadSessionExpired(true))
    } else{
        return get(response,"data");
    }

}, async function (error) {
    // Do something with response error
    console.log("Got the Response in error")
    console.log(error.response)
    console.log(error.config)
    let config=error.config;
    console.log("config error",config)
    const statusCode = get(error,"response.data.serviceResponseHeader.statusCode")
    console.log("statusCode",statusCode)
    if (SESSION_EXPIRED_STAT_CODE.includes(statusCode)  && !config.sent){
        config._retry=true;
        await RefreshTokenService();
        console.log("Finished Refresh Token")
        return axiosInstance.request(config)
    }else if(statusCode ===UNAUTH_STAT_CODE_101){
        store.dispatch(loadSessionExpired(true))
    }

    //store.dispatch(loadSessionExpired(true))
    console.log("interceptors error")
    return Promise.reject(error);
});
